const mockAudioMasteringData = [
    {
        "id": 138,
        "created_by": "John Doe",
        "total_songs": 1,
        "songs_count": 1,
        "mastered_songs": "0/1",
        "created": "2023-04-18T13:23:11.291237Z",
        "songs": [
            {
                "id": 90,
                "base_file": "",
                "genre": "Pop",
                "tag": "Test",
                "dynamic_object": true,
                "preset": "n",
                "intensity": 80,
                "loudness_object": true,
                "target_level": -14,
                "result_file": null,
                "preview_result": null,
                "preview_count": 0,
                "mastering_expedited": false
            }
        ],
        "songs_uploaded": true
    },
    {
        "id": 137,
        "created_by": "John Doe",
        "total_songs": 8,
        "songs_count": 0,
        "mastered_songs": "0/8",
        "created": "2023-04-18T13:17:39.886373Z",
        "songs": [],
        "songs_uploaded": false
    },
    {
        "id": 136,
        "created_by": "John Doe",
        "total_songs": 10,
        "songs_count": 0,
        "mastered_songs": "0/10",
        "created": "2023-04-18T13:06:54.896551Z",
        "songs": [],
        "songs_uploaded": false
    },
    {
        "id": 135,
        "created_by": "John Doe",
        "total_songs": 1,
        "songs_count": 1,
        "mastered_songs": "0/1",
        "created": "2023-04-18T13:05:29.923647Z",
        "songs": [
            {
                "id": 89,
                "base_file": "",
                "genre": "House",
                "tag": "Test Song",
                "dynamic_object": true,
                "preset": "g",
                "intensity": 94,
                "loudness_object": true,
                "target_level": -13,
                "result_file": null,
                "preview_result": null,
                "preview_count": 0,
                "mastering_expedited": false
            }
        ],
        "songs_uploaded": true
    },
    {
        "id": 134,
        "created_by": "John Doe",
        "total_songs": 1,
        "songs_count": 1,
        "mastered_songs": "1/1",
        "created": "2022-11-24T12:17:45.847961Z",
        "songs": [
            {
                "id": 88,
                "base_file": "",
                "genre": "House Music",
                "tag": "Test Song",
                "dynamic_object": true,
                "preset": "f",
                "intensity": 100,
                "loudness_object": true,
                "target_level": -10,
                "result_file": "",
                "preview_result": "",
                "preview_count": 2,
                "mastering_expedited": true
            }
        ],
        "songs_uploaded": true
    },
    {
        "id": 133,
        "created_by": "John Doe",
        "total_songs": 1,
        "songs_count": 1,
        "mastered_songs": "1/1",
        "created": "2022-11-23T11:27:33.798364Z",
        "songs": [
            {
                "id": 87,
                "base_file": "",
                "genre": "Deep House",
                "tag": "Song Demo",
                "dynamic_object": true,
                "preset": "b",
                "intensity": 75,
                "loudness_object": true,
                "target_level": -11,
                "result_file": "",
                "preview_result": "",
                "preview_count": 1,
                "mastering_expedited": true
            }
        ],
        "songs_uploaded": true
    },
    {
        "id": 132,
        "created_by": "John Doe",
        "total_songs": 1,
        "songs_count": 1,
        "mastered_songs": "1/1",
        "created": "2022-11-23T08:25:49.233659Z",
        "songs": [
            {
                "id": 86,
                "base_file": "",
                "genre": "Deep House",
                "tag": "My Demo Song",
                "dynamic_object": true,
                "preset": "b",
                "intensity": 70,
                "loudness_object": true,
                "target_level": -10,
                "result_file": "",
                "preview_result": "",
                "preview_count": 1,
                "mastering_expedited": true
            }
        ],
        "songs_uploaded": true
    },
    {
        "id": 131,
        "created_by": "John Doe",
        "total_songs": 3,
        "songs_count": 0,
        "mastered_songs": "0/3",
        "created": "2022-11-11T15:16:08.078279Z",
        "songs": [],
        "songs_uploaded": false
    },
    {
        "id": 130,
        "created_by": "John Doe",
        "total_songs": 2,
        "songs_count": 0,
        "mastered_songs": "0/2",
        "created": "2022-08-27T12:12:26.346418Z",
        "songs": [],
        "songs_uploaded": false
    },
    {
        "id": 129,
        "created_by": "John Doe",
        "total_songs": 1,
        "songs_count": 0,
        "mastered_songs": "0/1",
        "created": "2022-07-25T14:02:53.369861Z",
        "songs": [],
        "songs_uploaded": false
    }
]
export default mockAudioMasteringData;